import React from 'react';
import Tv from 'icons/tv.svg';
import Tablet from 'icons/tablet.svg';
import Computer from 'icons/computer.svg';
import ExternalLink from 'icons/external-link.svg';
import styles from './MediaList.module.css';
const MediaList = () => {
  return <ul data-sentry-component="MediaList" data-sentry-source-file="MediaList.tsx">
      <li className={styles.mediaListItem}>
        <Tablet aria-hidden className={styles.mediaIcon} focusable="false" data-sentry-element="Tablet" data-sentry-source-file="MediaList.tsx" />
        <a href="https://www.ur.se/vart-utbud/ur-play" target="_blank" rel="noopener" className={styles.link}>
          Mobil och surfplatta
          <ExternalLink className={styles.externalIcon} role="img" aria-label="Öppnas i nytt fönster" data-sentry-element="ExternalLink" data-sentry-source-file="MediaList.tsx" />
        </a>
      </li>
      <li className={styles.mediaListItem}>
        <Computer aria-hidden className={styles.mediaIcon} focusable="false" data-sentry-element="Computer" data-sentry-source-file="MediaList.tsx" />
        <a href="https://www.ur.se/vart-utbud/ur-play" target="_blank" rel="noopener" className={styles.link}>
          Dator
          <ExternalLink role="img" aria-label="Öppnas i nytt fönster" className={styles.externalIcon} data-sentry-element="ExternalLink" data-sentry-source-file="MediaList.tsx" />
        </a>
      </li>
      <li className={styles.mediaListItem}>
        <Tv aria-hidden className={styles.mediaIcon} focusable="false" data-sentry-element="Tv" data-sentry-source-file="MediaList.tsx" />
        <a href="https://www.ur.se/vart-utbud/ur-play" target="_blank" rel="noopener" className={styles.link}>
          TV
          <ExternalLink role="img" aria-label="Öppnas i nytt fönster" className={styles.externalIcon} data-sentry-element="ExternalLink" data-sentry-source-file="MediaList.tsx" />
        </a>
      </li>
    </ul>;
};
export default MediaList;